import workoutExercisesBg from '../../../../Assets/Images/GymTvThumbnails/thumbnail-workout-programme@2x.png';
import wearableStatsBg from '../../../../Assets/Images/GymTvThumbnails/thumbnail-calories@2x.png';
import workoutPlaybackBg from '../../../../Assets/Images/GymTvThumbnails/thumbnail-playback@2x.png';
import generalLeaderboardsBg from '../../../../Assets/Images/GymTvThumbnails/thumbnail-global-leaderboard@2x.png';
import workoutLeaderboardsBg from '../../../../Assets/Images/GymTvThumbnails/thumbnail-workout-leaderboard@2x.png';
import youtubeBg from '../../../../Assets/Images/GymTvPreviews/preview_youtube.png';

export const convertModalKeyToModalName = modalKey => {
    switch (modalKey) {
        case 0:
            return 'Before class';
        case 1:
            return 'During class';
        case 2:
            return 'After class';
        case 3:
            return 'Between classes';
        default:
            return 'Before class';
    }
};

export const convertPreviewItemKeyToTitle = key => {
    switch (key) {
        case 0:
            return 'Workout exercises';
        case 1:
            return 'Wearable stats';
        case 2:
            return 'Workout playback';
        case 3:
            return 'General leaderboards';
        case 4:
            return 'Workout leaderboards';
        case 5:
            return 'Youtube video';
        default:
            return 'Untitled';
    }
};

export const convertPreviewItemKeyToDescription = key => {
    switch (key) {
        case 0:
            return "Show a workout's exercises to be performed.";
        case 1:
            return 'Members max HR, Calories & Heartrate taken live from their wearables.';
        case 2:
            return 'Show a workout in action from start to finish in real time.';
        case 3:
            return 'Pick a general leaderboard such as calories per month.';
        case 4:
            return 'Pick a workout leaderboard to display. Good for competitions.';
        case 5:
            return 'Choose any video to display e.g. one that promotes your gym or class.';
        default:
            return 'Untitled';
    }
};

// choose workout modal
export const convertWorkoutTypePreviewKeyToTitle = key => {
    switch (key) {
        case 0:
            return 'Workout of the day';
        case 1:
            return 'Challenge of the week';
        case 2:
            return 'Custom workout';
        default:
            return 'Untitled';
    }
};

export const convertWorkoutTypePreviewKeyToDescription = key => {
    switch (key) {
        case 0:
            return "Taken from your schedule or Tona's workout of the day page";
        case 1:
            return "Taken from your schedule or Tona's challenge page";
        case 2:
            return 'Choose your own workout to be displayed';
        default:
            return '';
    }
};

export const getPreviewItemBackgroundImage = type => {
    switch (type) {
        case 0:
            return workoutExercisesBg;
        case 1:
            return wearableStatsBg;
        case 2:
            return workoutPlaybackBg;
        case 3:
            return generalLeaderboardsBg;
        case 4:
            return workoutLeaderboardsBg;
        case 5:
            return youtubeBg;
        default:
            return workoutExercisesBg;
    }
};

export const getStartOrFinishLabel = type => {
    switch (type) {
        case 0:
            return 'Start';
        case 2:
            return 'Finish';
        default:
            return;
    }
};

export const getBeforeOrAfterLabel = type => {
    switch (type) {
        case 0:
            return 'before classes start';
        case 2:
            return 'after classes finish';
        default:
            return;
    }
};

export const getDurationInputName = type => {
    switch (type) {
        case 0:
            return 'start_display';
        case 2:
            return 'end_display';
        default:
            return;
    }
};

export const getDurationInputValue = (type, startDisplay, endDisplay) => {
    switch (type) {
        case 0:
            return startDisplay;
        case 2:
            return endDisplay;
        default:
            return;
    }
};

export const convertFormatToWithoutHours = format => {
    const intervalsArrray = format.split(':');
    return `${intervalsArrray[1]}:${intervalsArrray[2]}`;
};

export const convertFormatToWithHours = format => {
    return `00:${format}`;
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/utils.js